import FeatureGates from '@atlaskit/feature-gate-js-client';
import { AnalyticsClient } from '../../../../utilities/analytics/analytics-web-client';
import { AidFrontendExperiment } from '../../../../providers/FeatureGates';

type ApplicationData = {
  coreApplication: string;
  experience?: string;
};

export const checkDirectSignupExperiment = ({
  applicationData,
  analyticsClient,
}: {
  applicationData?: ApplicationData;
  analyticsClient?: AnalyticsClient;
}) => {
  const experimentKey = AidFrontendExperiment.GHOST_ADVANCED_COBRANDING_DIRECT_SIGNUP;
  try {
    const cohortValue = FeatureGates.getExperimentValue(experimentKey, 'cohort', 'not-enrolled') as
      | 'variation'
      | 'control'
      | 'not-enrolled';

    analyticsClient?.trackingEvent({
      page: 'trello-direct-signup',
      action: 'exposed',
      subject: experimentKey,
      attributes: {
        flagKey: experimentKey,
        group: cohortValue,
        application: applicationData?.coreApplication,
        experience: applicationData?.experience,
      },
    });

    return cohortValue === 'variation';
  } catch (error) {
    analyticsClient?.operationalEvent({
      page: 'trello-direct-signup',
      action: 'failed',
      subject: experimentKey,
      attributes: {
        flagKey: experimentKey,
        application: applicationData?.coreApplication,
        experience: applicationData?.experience,
        errorName: error?.name,
        errorStack: error?.stack,
        errorMessage: error?.message,
        errorCode: error?.code,
      },
    });

    console.error(`Error checking ${experimentKey}`, error);
    return false;
  }
};
